import { SyntheticEvent, useCallback, useState } from "react";
import { useMatch, useNavigate } from 'react-router';

import { UserSettingsRoutesConfig } from "domains/userSettings/Routes";
import { ESettingsNavTab } from "modules/layout/const";
import { platformSwaggerRoutesConfig } from "domains/platformSwagger/routes";

const TAB_URL_MAP: Record<ESettingsNavTab, string> = {
  [ESettingsNavTab.platform]: UserSettingsRoutesConfig.settings.path,
  [ESettingsNavTab.swagger]: platformSwaggerRoutesConfig.platformSwagger.path,
  [ESettingsNavTab.general]: UserSettingsRoutesConfig.teamGeneral.path,
  [ESettingsNavTab.teammates]: UserSettingsRoutesConfig.teammates.path,
  [ESettingsNavTab.notifications]: UserSettingsRoutesConfig.teamNotifications.path,
}

export const useSettingsNavTabs = () => {
  const navigate = useNavigate();

  const isTeamGeneralPage = Boolean(
    useMatch(UserSettingsRoutesConfig.teamGeneral.path),
  );
  const isTeamNotificationsPage = Boolean(
    useMatch(UserSettingsRoutesConfig.teamNotifications.path),
  );
  const isTeammatesPage = Boolean(
    useMatch(UserSettingsRoutesConfig.teammates.path),
  );
  const isSwaggerPage = Boolean(
    useMatch(platformSwaggerRoutesConfig.platformSwagger.path),
  );

  let initValue = ESettingsNavTab.platform;

  if (isTeamGeneralPage) initValue = ESettingsNavTab.general;
  if (isTeamNotificationsPage) initValue = ESettingsNavTab.notifications;
  if (isTeammatesPage) initValue = ESettingsNavTab.teammates;
  if (isSwaggerPage) initValue = ESettingsNavTab.swagger;

  const [currentTab, setCurrentTab] = useState(initValue);

  const handleChangeTab = useCallback((_event: SyntheticEvent, newValue: ESettingsNavTab) => {
    setCurrentTab(newValue);

    navigate(TAB_URL_MAP[newValue]);
  }, [setCurrentTab, navigate]);

  return {
    currentTab,
    handleChangeTab,
  }
}